module.exports = __webpack_public_path__ + "img/kr.kr9408e69.svg";